import { render, staticRenderFns } from "./MensajePedidoEditar.vue?vue&type=template&id=a19ce696&scoped=true&"
import script from "./MensajePedidoEditar.vue?vue&type=script&lang=js&"
export * from "./MensajePedidoEditar.vue?vue&type=script&lang=js&"
import style0 from "./MensajePedidoEditar.vue?vue&type=style&index=0&id=a19ce696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ce696",
  null
  
)

export default component.exports